<template>
  <div class="custom-table--detail">
    <copy-notification
      :opened="copyConfirmVisible"
      :text="'zkopirovanoDoSchranky'"
      @close="copyConfirmVisible = false"
    />

    <h3>{{ $t("vsechnyZpravy") }}</h3>

    <message-table-filter
      :from="from"
      :to="to"
      :rows="messages"
      :all="allMessages"
      :to-apply-filter="applyFilter"
      :order-by="sort"
      :order-type="sortType"
      :count="allMessagesLength"
      :fulltext-disabled="true"
      :no-type="true"
      @filteredItems="filteredMessages"
      @setSearch="setSearch($event)"
      @setTo="setTo"
      @resetSearch="resetSearch"
      @setFrom="setFrom"
      @resetPaging="page = 0"
    />

    <div>
      <span
        v-if="!loadingData && messages.length > 0"
        id="exportbutton"
        class="link"
        @click="openedExportSelect = true"
      >
        {{ $t("exportZprav") }}
      </span>
      <div v-if="openedExportSelect" class="d-flex">
        <span
          id="exportbutton"
          class="btn btn-sm btn-outline-primary mt-2 d-flex align-items-center mr-1"
          @click="
            () => {
              openedExportSelect = false
              exportMessages('csv')
            }
          "
        >
          {{ $t("CSV") }}
        </span>
        <span
          id="exportbutton"
          class="btn btn-sm btn-outline-primary mt-2 d-flex align-items-center"
          @click="
            () => {
              openedExportSelect = false
              exportMessages('xlsx')
            }
          "
        >
          {{ $t("XLSX") }}
        </span>
      </div>
    </div>
    <div class="border-top mt-3 pb-3" />
    <app-loader v-if="loadingData" />
    <div v-if="!messages.length && !loadingData && !noDeliveries">
      {{ $t("zadneZpravyKZobrazeni") }}
    </div>
    <div v-if="!messages.length && !loadingData && noDeliveries">
      {{ $t("noDeliveriesYet") }}
    </div>

    <div v-if="messages.length > 0" class="position-relative w-100">
      <div id="messages" class="table-responsive">
        <table class="table table-main table-hover">
          <thead>
            <tr>
              <th
                v-for="(column, index) in columns"
                :key="index"
                :style="{ 'min-width': column.minWidth }"
                :class="{ isHidden: !column.visible }"
              >
                <span v-if="column.sortable != true">
                  {{ $t(column.name) }}
                </span>
                <span v-else>
                  <div class="title" @click="sortMessagesBy(column.type)">
                    {{ $t(column.name) }}
                  </div>
                  <div v-if="sort == column.type" class="sorting">
                    <span v-if="sortType == 'desc'">▼</span>
                    <span v-if="sortType == 'asc'">▲</span>
                  </div>
                </span>
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, item_index) in messages" :key="item_index">
              <td
                v-for="(column, column_index) in columns"
                :key="column_index"
                :style="{ width: column.minWidth }"
                :class="{
                  isHidden: !column.visible
                }"
              >
                <span v-if="column.type == 'custDeviceName'">
                  <span
                    :style="{ maxWidth: column.minWidth }"
                    class="gray-text-light"
                    style="display: block; word-wrap: break-word"
                  >
                    {{ item[column.type] }}
                  </span>
                </span>
                <span v-else-if="column.type == 'requestTime'">
                  <span v-html="$filters.dateTime(item.requestTime)" />
                </span>
                <span v-else-if="column.type == 'state'">
                  <span v-if="item.state === 'inFront'" class="atom-tag">
                    {{ $t("veFronte") }}
                  </span>
                  <span v-else-if="item.state == 'OK'" class="atom-tag atom-tag--success">OK</span>
                  <span v-else class="atom-tag atom-tag--warning">?</span>
                </span>
                <div v-else-if="column.type == 'signal'">
                  <snr-icon :last-message-in="item" />
                </div>
                <div v-else-if="column.type == 'port'">
                  <span v-if="item.message != null" class="font-weight-normal">
                    {{ item.message.port }}
                  </span>
                </div>
                <div v-else-if="column.type == 'payload'">
                  <img v-if="item.message.encdata != null" src="@/assets/icons/ico-ico-enc-payload.svg" />
                  {{ item.message.data != null ? item.message.data : $filters.strLimit(item.message.encdata, 11) }}
                  <span
                    class="ml-1 copy gray-text-light"
                    @click="copyToClipboard(item.message.data != null ? item.message.data : item.message.encdata)"
                  >
                    <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                  </span>
                </div>
                <span v-else>
                  {{ item[column.type] }}
                </span>
              </td>
              <td />
            </tr>
          </tbody>
        </table>

        <table :class="{ showShadow: showShadow }" class="table table-hover fixed-first-column">
          <thead>
            <tr>
              <th>
                <span v-if="columns[0].sortable != true">
                  {{ $t("device") }}
                </span>
                <span v-else class="d-flex align-items-center">
                  <div class="title" @click="sortMessagesBy(columns[0].type)">
                    {{ $t("device") }}
                  </div>
                  <div v-if="sort == columns[0].type" class="sorting">
                    <span v-if="sortType == 'desc'">▼</span>
                    <span v-if="sortType == 'asc'">▲</span>
                  </div>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, item_index) in messages" :key="item_index">
              <td :style="{ width: columns[0].minWidth }">
                <span
                  :style="{ maxWidth: columns[0].minWidth }"
                  class="gray-text-light"
                  style="display: block; word-wrap: break-word"
                >
                  {{ item.custDeviceName }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table table-hover fixed-last-column" :class="{ showShadow: showShadow }">
          <thead>
            <tr>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, item_index) in messages" :key="item_index">
              <td>
                <span class="link" @click="showMessage(item)">
                  {{ $t("zobrazit") }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="messages.length > 0" class="custom-table__footer d-flex align-items-center justify-content-between">
      <div class="custom-table__footer__actions align-items-center" />

      <paging
        :page="{
          currentPage: page,
          rowsPerPage: rowsPerPage,
          itemsTotalCount: allMessagesCount,
          itemsCount: messages.length
        }"
        @nextPage="page++"
        @prevPage="page--"
        @rowsPerPage="rowsPerPage = $event"
        @reloadItems="reloadItems()"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash"
import axios from "axios"
import Paging from "@/components/paging/paging.vue"
import MessageFilter from "@/components/filters/message-table-filter.vue"
import Loader from "@/components/loader.vue"
import Notify from "@/components/notify/notify.vue"
import SnrIcon from "@/components/boxes/snrIcon.vue"
import { useLoraStore } from "@/store/modules/devices/lora"

export default {
  components: {
    paging: Paging,
    "snr-icon": SnrIcon,
    "message-table-filter": MessageFilter,
    "app-loader": Loader,
    "copy-notification": Notify
  },
  props: {
    items: Array,
    device: Object,
    deviceId: Number,
    reloadDM: Boolean
  },
  setup() {
    const loraStore = useLoraStore()

    return { loraStore }
  },
  data() {
    return {
      sort: "requestTime",
      sortType: "desc",
      rowsPerPage: 20,
      page: 0,
      openedRowsSelect: false,
      selectedRows: [],
      selectedAll: false,
      isSelectedAllOnPage: false,
      toggledAllRows: false,
      copyConfirmVisible: false,
      messages: [],
      search: "",
      from: "",
      to: "",
      inFront: [],
      inFrontMessages: [],
      allMessages: [],
      dateChanged: false,
      upMessagesLength: 0,
      downMessagesLength: 0,
      preloadedUpMessages: [],
      preloadedDownMessages: [],
      preloadedMessages: [],
      loadedComplete: false,
      applyFilter: false,
      openedExportSelect: false,
      loadingData: true,
      noMessages: false,
      noDeliveries: false,
      tableWidth: 0,
      columns: [
        {
          type: "custDeviceName",
          name: "device",
          sortable: false,
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "deviceId",
          name: "deviceId",
          sortable: false,
          visible: true,
          minWidth: "250px",
          order: 2
        },
        {
          type: "requestTime",
          name: "requestTime",
          sortable: true,
          visible: true,
          minWidth: "180px",
          order: 2
        },
        {
          type: "state",
          name: "state",
          sortable: false,
          visible: true,
          minWidth: "120px",
          order: 3
        },
        {
          type: "signal",
          name: "signal",
          sortable: false,
          visible: true,
          minWidth: "80px",
          order: 4
        },
        {
          type: "port",
          name: "port",
          sortable: false,
          visible: true,
          minWidth: "80px",
          order: 5
        },
        {
          type: "payload",
          name: "payload",
          sortable: false,
          visible: true,
          minWidth: "350px",
          order: 6
        }
      ],
      tableColumnsDefault: {
        requestTime: {
          show: true,
          order: 2,
          title: "requestTime"
        },
        state: {
          show: true,
          order: 3,
          title: "state"
        },
        signal: {
          show: true,
          order: 4,
          title: "signal"
        },
        port: {
          show: true,
          order: 5,
          title: "signal"
        },
        payload: {
          show: true,
          order: 6,
          title: "payload"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false
    }
  },
  computed: {
    lastMessageIn() {
      return this.device.lastMessageIn
    },
    lastMessageOut() {
      return this.device.lastMessageOut
    },
    allMessagesLength() {
      return this.upMessagesLength + this.downMessagesLength
    },
    dateChange() {
      const { to, from } = this
      return {
        from,
        to
      }
    },
    lastMessages() {
      const { lastMessageIn, lastMessageOut } = this
      return {
        lastMessageIn,
        lastMessageOut
      }
    }
  },
  watch: {
    dateChange: {
      handler: function (val) {
        if (val.from != "1970-01-01T00:00:00.000Z") {
          this.setApplyFilter()
        }
      },
      deep: true
    },
    lastMessages: {
      handler() {
        this.reloadDeviceInfo()
      },
      deep: true
    },
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    messages() {
      this.inFront = _.filter(this.messages, ["state", "inFront"])
    },
    reloadDM() {
      if (this.reloadDM == true) {
        this.updateByNowTime()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })

    this.updateByNowTime()
    if (localStorage.rowsPerPage) {
      var rows1 = localStorage.rowsPerPage
      this.rowsPerPage = rows1
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }
    this.updateResponsiveTable()
  },
  methods: {
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "messages")
    },
    async updateByNowTime() {
      console.log("messages.vue updateByNowTime")
      this.noMessages = false
      let device = await this.reloadDevice()

      if (device) {
        /* TODO delete
        let useDate = device.lastMessageOut;
        if (device.lastMessageIn > device.lastMessageOut) {
          useDate = device.lastMessageIn;
        } else {
          useDate = device.lastMessageOut;
        }
        console.log(useDate);
        */

        const parsedTo = new Date()

        let fr = String(this.from)
        let tt = String(this.to)
        if (this.from == "1970-01-01T00:00:00.000Z") {
          const dateFrom1 = new Date(parsedTo - 1 * 24 * 60 * 60 * 1000)
          dateFrom1.setHours(0, 0, 0, 0)
          this.from = dateFrom1.toISOString()
        } else if ((new Date(tt) - new Date(fr)) / 1000 / 60 / 60 / 24 > 30) {
          dateFrom1.setHours(0, 0, 0, 0)
          const dateFrom1 = new Date(parsedTo - 1 * 24 * 60 * 60 * 1000)
          this.from = dateFrom1.toISOString()
        }

        parsedTo.setHours(23, 59, 59, 999)
        this.to = parsedTo.toISOString()

        console.log("messages.vue this.from: " + this.from)
        console.log("messages.vue this.to: " + this.to)

        this.$emit("setReloadDM", false)

        this.updateResponsiveTable()
      }
    },
    async reloadDevice() {
      console.log("messages.vue reloadDevice")
      return axios
        .get(process.env.VUE_APP_API + "/http/endpoints/" + this.deviceId, {})
        .then((response) => {
          return response.data.data
        })
        .catch(() => {
          return true
        })
    },
    async reloadDeviceInfo() {
      return axios
        .get(process.env.VUE_APP_API + "/http/endpoints/" + this.deviceId, {})
        .then((response) => {
          this.device = response.data.data
          this.this.setDateRange()
          return true
        })
        .catch(() => {
          return true
        })
    },
    async setApplyFilter() {
      this.page = 0
      console.log("messages.vue setApplyFilter")
      this.applyFilter = false
      let messagesLoaded = await this.loadMessages()
      if (messagesLoaded) {
        this.applyFilter = true
        return true
      }
    },
    setDateRange() {
      console.log("messages.vue setDateRange()")
      let now = new Date()
      now.setHours(0, 0, 0, 0)
      const dateTo = now
      const dateFrom = new Date(dateTo - 31 * 24 * 60 * 60 * 1000)
      this.from = dateFrom.toISOString()
      this.to = now.toISOString()
    },
    async loadMessages() {
      console.log("messages.vue loadMessages")
      this.loadedComplete = false
      this.loadingData = true
      this.preloadedDownMessages = []

      console.log("load messages from: " + this.from)
      console.log("load messages to: " + this.to)

      let query = "/http/endpoints/" + this.deviceId + "/deliveries/full-detail/?sort="

      if (this.sortType == "asc") {
        query = query + "%2B" + this.sort
      } else {
        query = query + "%2D" + this.sort
      }

      /**
       * search string is not empty, adding search string to search parameter
       */

      if (this.search != "") {
        query = query + "&search=%2B" + this.search + "*"
      }
      /** add paging to the search query */
      query =
        query +
        "&from=" +
        this.from +
        "&to=" +
        this.to +
        "&offset=" +
        this.page * this.rowsPerPage +
        "&limit=" +
        this.rowsPerPage

      return axios
        .get(process.env.VUE_APP_API + query, {})
        .then((result) => {
          console.log(result)
          this.allMessagesCount = result.data.metadata.count
          this.messages = result.data.data

          for (let i = 0; i < this.messages.length; i++) {
            let message = this.messages[i]
            if (message.code >= 200 && message.code < 300) message.state = "OK"
            else message.state = message.code
            message.type = "up"
            message.snr = ""
            message.rssi = ""
            let gws = message.message.gws
            if (gws != undefined) {
              let sortedBySnr = _.orderBy(gws, "snr", "desc")
              let largestSnr = sortedBySnr[0].snr
              message.snr = largestSnr
              let sortedByRssi = _.orderBy(gws, "rssi", "desc")
              let largestRssi = sortedByRssi[0].rssi
              message.rssi = largestRssi
            }
            this.messages[i] = message
          }

          console.log("this.messages")
          console.log(this.allMessagesCount)
          console.log(this.messages)
          this.loadingData = false

          this.$nextTick(() => {
            this.updateResponsiveTable()
          })
        })
        .catch((result) => {
          if (result.status == 303) {
            this.messages = []
            this.noDeliveries = true
            this.loadingData = false
          }
        })
    },
    reloadItems() {
      console.log("messages.vue reloadItems")
      this.selectedRows = []
      this.loadMessages()
    },
    resetSearch() {
      let now = new Date()
      const dateTo = now
      const dateFrom = new Date(dateTo - 1 * 24 * 60 * 60 * 1000)
      this.from = dateFrom.toISOString()
      this.to = now.toISOString()
    },
    toggleOpenedRowSelect() {
      this.openedRowsSelect = this.openedRowsSelect ? false : true
    },
    filteredMessages(messages) {
      if (messages != undefined) {
        this.messages = messages
      }
    },
    sortMessagesBy(sortBy) {
      this.sortBy = sortBy

      if (this.sortType == "asc") {
        this.sortType = "desc"
      } else {
        this.sortType = "asc"
      }
      this.sort = new String(sortBy)
      this.dateChanged = false
      this.reloadItems()
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    setTo(to) {
      console.log("setTo")
      console.log(to)
      if (to != "1970-01-01T00:00:00.000Z") {
        let t = new Date(Date.parse(to))
        t.setHours(23, 59, 59, 999)
        this.to = t.toISOString()
      } else {
        this.to = to
      }
    },
    setFrom(from) {
      console.log("setFrom")
      console.log(from)
      if (from != "1970-01-01T00:00:00.000Z") {
        let f = new Date(Date.parse(from))
        f.setHours(0, 0, 0, 0)
        this.from = f.toISOString()
      } else {
        this.from = from
      }
      console.log(from)
    },
    setSearch(search) {
      console.log(search)
      this.search = search
      this.reloadItems()
    },
    showMessage(message) {
      this.$emit("showMessage", message)
    },
    exportMessages(type) {
      this.$store.commit("modals/setWaitingLoader", this.$t("Exportuji data, čekejte prosím..."))
      let messagesToExport = []
      this.messages.forEach((message) => {
        if (message.message != null) {
          messagesToExport.push(message.message)
        }
      })

      axios
        .post(process.env.VUE_APP_APICMS + "/exportMessages?format=" + type, messagesToExport, {
          responseType: "blob"
        })
        .then((response) => {
          let f = new Date(Date.parse(this.from) + 2 * 60 * 60 * 1000)
          let t = new Date(Date.parse(this.to) + 2 * 60 * 60 * 1000)
          let dateFrom = f.toISOString()
          let dateTo = t.toISOString()
          dateFrom = dateFrom.split("T")
          dateTo = dateTo.split("T")
          console.log("dateFrom", dateFrom)
          dateFrom = dateFrom[0].split("-")
          dateTo = dateTo[0].split("-")
          let fileNameSuffix =
            "_" +
            this.deviceId +
            "_" +
            dateFrom[0] +
            dateFrom[1] +
            dateFrom[2] +
            "_" +
            dateTo[0] +
            dateTo[1] +
            dateTo[2]
          if (response.data != undefined) {
            var fileName, blob
            if (type == "csv") {
              fileName = "export" + fileNameSuffix + ".csv"
              blob = new Blob([response.data], {
                type: "text/csv;charset=utf-8;"
              })
            } else if (type == "xlsx") {
              fileName = "export" + fileNameSuffix + ".xlsx"
              blob = new Blob([response.data], {
                type: "application/vnd.ms-excel"
              })
            }

            if (window.navigator.msSaveBlob) {
              // FOR IE BROWSER
              navigator.msSaveBlob(blob, fileName)
            } else {
              // FOR OTHER BROWSERS
              var csvUrl = URL.createObjectURL(blob)
              const link = document.createElement("a")
              link.setAttribute("href", csvUrl)
              link.setAttribute("download", fileName)
              link.click()
              this.$store.commit("modals/setWaitingLoader", "")
            }
          }
        })
        .catch((error) => {
          if (error.status) {
            let err = []
            err.errors = []
            err.errors.push({
              message: error.status + " " + error.statusText
            })
            this.errorsToTranslate.push(err)
            if (this.errorsToTranslate.length > 0) {
              this.openedError = true
            }
          }
          this.$store.commit("modals/setWaitingLoader", "")
        })
    },
    async flushQueue() {
      console.log("messages.vue flushQueue")
      axios
        .post(process.env.VUE_APP_API + "/http/endpoints/" + this.deviceId + "/flush-queue", {})
        .then(() => {
          this.updateByNowTime()
        })
        .catch(() => {})
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      this.showSidebarTableColumnOrder = false
      this.$nextTick(() => {
        this.updateResponsiveTable()
      })
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    }
  }
}
</script>

<style lang="scss" scoped></style>
